export const guarantorFormTitleV3 = 'Cadastre sua pessoa avalista';

export const guarantorFormDescriptionV3 =
  'Essa pessoa apoiará seu financiamento, como uma garantia. Ela passará por uma análise de crédito e, caso seja aprovada, assinará o documento para contratação do financiamento.';

export const guarantorFormEndDescription =
  'Você pode indicar uma pessoa que você conheça e que, de preferência, seja da sua família. 🏠';
